import { DEFAULT_LOCALE } from '../actions/i18n';

export const localeSelector = (state) => state.data.i18n.locale;
export const isDefaultLocaleSelector = (state) => state.data.i18n.locale === DEFAULT_LOCALE;
